export default "<div id=\"app\">\n  {{ message }}\n</div>\n"